import React from 'react';
import Header from '../JobPage/Header';
import Footer from '../JobPage/Footer';
import { CategoryTabs } from './CategoryTab';
import { JobSeekerSection } from './JobSeekerSection';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';

export function RemoteStats() {
  const { activeTab } = window.state || {};
  
  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col">
      <Header />
      <CategoryTabs activeTab={activeTab} />
      <Container size="default" className="flex-1 py-10">
        <Stack spacing="xl" className="mt-20">
          <section className="text-left ml-[90px] mt-2.5">
            <Text size="lg" className="text-foreground mb-4">
              % of open jobs at tech companies with a remote option
            </Text>
            <img 
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/d12a89636209df9fea6099c0590bb96c352a3ddd14a94ea3b9f877a332eb0aa0?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
              alt="Main content" 
              className="w-full max-w-[1000px] rounded-2xl mb-10" 
            />
          </section>
        </Stack>
      </Container>
      <JobSeekerSection />
      <Footer />
    </div>
  );
}
